module.exports = __webpack_public_path__ + "media/images/footer/illu-a3d3719d2a28b64a0081a039614225be.png";